import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ActivatedRoute, Router, Routes} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UserIdleService} from 'angular-user-idle';
import {GraphService} from 'src/app/services/graph.service';
import {SsoSecurityService} from 'src/app/services/sso-security.service';
import {UserService} from 'src/app/services/user.service';
import {environment} from 'src/environments/environment';
import {IdlePopupComponent} from '../idle-popup/idle-popup.component';
import {UserData} from '../model/user-data';
import {UsersDataResponse} from '../model/users-data-response';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  title = 'Loblaw';







  menuList = [
    {
      label: 'Dashboard',
      path: './dashboard',
      key:'dashboard',
    //  index: 0
    },
    {
      label: 'Order Summary',
      path: './order-summary',
      key:'ordersummary',
      //index: 1
    },
    {
      label: 'Reports',
      path: './reports',
      key:'reports',
    },
    {
      label: 'Administration',
      path: './administration',
      key:'administration',
      //index: 1
    },
    {
      label: 'Store Management',
      path: './store-management',
      key:'storemanagement',
      //index: 1
    }

  ];
  navLinks: any[];
  activeLinkIndex = -1;
  activeLink: any;
  background = '';
  isJobAids:boolean=false;
  user: UsersDataResponse = null
  userData: UserData = null;
 count:number;
  switchLang(lang: string) {
    this.translate.use(lang);
  }
  popupopened=false;

  constructor(private route: ActivatedRoute,
    private router: Router, private userservice: UserService, private changeDetector: ChangeDetectorRef,public translate: TranslateService,
    private userIdle: UserIdleService,private dialog:MatDialog,private graphservice:GraphService,private authservice:SsoSecurityService) {
      translate.addLangs(['en', 'fr']);
      translate.setDefaultLang('en');
      this.userservice.getCurrentUser().subscribe(data=>{
        this.user=data;
        this.userData=data.userData;
        this.userIdle.startWatching();
        this.userIdle.onTimerStart().subscribe(count => {
          console.log(this.count=count),
          this.count=count,

        (this.cancel===false && this.popupopened===false)?this.timeoutpopup():this.popupopened
      });

         //Start watch when time is up.
        this.userIdle.onTimeout().toPromise().then(v=>{
          this.logout();
        })
          this.switchLang(this.userData.language.toLowerCase());
        this.navLinks = this.filterUserBasedMenu();
        if(this.userData.roleId>3){
          this.isJobAids=true;
          this.jobAidsMenu();
        }

      })

  }
  ngOnInit(): void {



  }

 lcl:boolean=false;
 sdm:boolean=false;
 pharmaphix:boolean=false;
 banners:string[]=[];
 enableMulti:boolean=false;
jobAidsMenu(){
 this.enableMulti=false
  this.banners=[];
  this.user.stores.forEach(store=>{
    switch (store.banner) {
      case 'SDM':
        this.banners.push("SDM");
      this.sdm=true;
      break;
      case 'LCL':
      this.lcl=true;
      this.banners.push('LCL');
      break;
      case 'PHX':
      this.banners.push('PHARMAPRIX');
      this.pharmaphix=true;
        break
      default:
        break;
    }
  })
  if(this.banners.length>1){
    this.enableMulti=true;
  }else{
    this.enableMulti=false;
  }
}

  refreshData() {
    let currentUrl = this.router.url;


    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    })

  }



  verifyEsa() {
    let valid = false;
    this.user.stores.forEach(element => {
      if (element.electronicSignatureAttestation) {
        valid = true;
      }
    });

    return valid
  }


  buildNavItems(routes: Routes) {
    let rolecode = this.userData.roleId;
    routes = this.filterUserBased(routes, rolecode);
    return (routes)
      .filter(route => route.data)
      .map(({ path = '', data }) => ({
        path: path,
        label: data.label,
        icon: data.icon
      }));


  }

  filterUserBasedMenu() {
    let screens = this.userData.usersRole.screensAccess;
    let roleaccess = screens.split(',');
    let rout = [];
    for (let menu of this.menuList) {
      for (var value1 of roleaccess) {
        if (menu.key === value1) {

          rout.push(menu)
        }
      }
    }
    return rout;
  }

  filterUserBased(routes, rolecode) {
    let screens = this.userData.usersRole.screensAccess;
    let roleaccess = screens.split(',');
    let rout = [];
    for (let route of routes) {
      for (var value1 of roleaccess) {
        if (route.path === value1) {

          rout.push(route)
        }
      }
    }
    return rout;
  }


  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
  logout(){
    this.userservice.updateLogoutStatus(this.user.userData.sequenceNumber).subscribe(data=>{
      this.userservice.setLogOut();
      this.authservice.logoutRedirect();
    })
}
cancel:boolean=false;
timeoutpopup(){
  this.popupopened=true;
  this.cancel=false;
  let english="Session is expiring in seconds"
  let french="La session expirera dans quelques secondes";
  this.dialog.open(IdlePopupComponent, {

    data: {
      title: "Confirmation",
      message:this.userData.language==="EN"?english:french,
      timeinseconds:this.count

    }
    , panelClass: 'my-class'
  }).afterClosed().subscribe(res => {
    if (res === "Yes") {
      this.popupopened=true;
      this.logout();

    } else
      if (res === "Cancel") {
        this.popupopened=false;
        this.cancel=true;
        this.restart();
        this.cancel=false;
    //this.stopWatching();
    //this.startWatching();
      }
  })
}
tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
 window.location.href=environment.NCTM_UI_HOST;
}
}
